import { makeStyles } from '@material-ui/core/styles';

export const baseStyles = makeStyles((theme) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '10px',
    [theme.breakpoints.down(600)]: {
      padding: '10px 0'
    }
  },
  h1: {
    fontSize: '2.375rem',
    marginBottom: '1.25rem',
    fontWeight: 300,
    lineHeight: '2.625rem',
    color: theme.palette.primary.light
  },
  flosIcon: {
    marginBottom: 20
  },
  spacingNone: {
    marginBottom: 0
  },
  spacingExtraSmall: {
    marginBottom: '0.25rem !important'
  },
  spacingSmall: {
    marginBottom: '0.5rem !important'
  },
  spacingDense: {
    marginBottom: '0.875rem !important'
  },
  spacingNormal: {
    marginBottom: '1.250rem !important'
  },
  spacingOversize: {
    marginBottom: '1.563rem !important'
  },
  spacingSupersize: {
    marginBottom: '1.70rem !important'
  },
  spacingLarge: {
    marginBottom: '2.0rem !important'
  },
  spacingXLarge: {
    marginBottom: '2.5rem !important'
  },
  spacingExtraLarge: {
    marginBottom: '3.125rem !important'
  },
  spacingHuge: {
    marginBottom: '3.437rem !important'
  },
  fontWeightLight: {
    fontWeight: 300
  },
  fontWeightNormal: {
    fontWeight: 400
  },
  fontWeightHeavy: {
    fontWeight: 600
  },
  fontWeightExtraHeavy: {
    fontWeight: 900
  },
  renderHtml: {
    '& p': {
      marginBottom: '1.250rem'
    }
  },
  modalWrapper: {
    padding: '15px 30px',
    '& p': {
      fontWeight: 300,
      color: '#202245',
      fontSize: theme.typography.pxToRem(20),
      lineHeight: '1.8rem'
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0
    }
  }
}));
